import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlUtilService } from '../url/url.util.service';
import { catchError, finalize, first, map, Observable } from 'rxjs';
import { SpinnerService } from '../spinner.service';
import { Environment } from 'src/environments/environment.class';
import { ReponseCoordonneesCredit } from '../../api/model/reponse-coordonnees-credit.model';
import { RequeteModifierCoordonneesCredit } from '../../api/model/requete-modifier-coordonnees-credit.model';

@Injectable({
  providedIn: 'root',
})
export class ChangementCoordonneeCreditFiservAccesDService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly urlService: UrlUtilService,
    readonly spinnerService: SpinnerService,
    private readonly environment: Environment
  ) {}

  obtenirCoordooneesCredit$(): Observable<ReponseCoordonneesCredit> {
    this.spinnerService.afficher();
    return this.httpClient
      .get<ReponseCoordonneesCredit>(
        this.urlService.getChangementAdresseAccesDUrl(this.environment.creditFiservEndpoint)
      )
      .pipe(
        first(),
        map((data) => {
          return data;
        }),
        catchError((err) => {
          throw err;
        }),
        finalize(() => this.spinnerService.cacher())
      );
  }

  patchCoordooneesCredit$(requeteModificationCoordonneesCredit: RequeteModifierCoordonneesCredit): Observable<void> {
    this.spinnerService.afficher();
    return this.httpClient
      .patch<void>(
        this.urlService.getChangementAdresseAccesDUrl(this.environment.creditFiservEndpoint),
        requeteModificationCoordonneesCredit
      )
      .pipe(
        catchError((err) => {
          throw err;
        }),
        finalize(() => this.spinnerService.cacher())
      );
  }
}
